import {
    IRef,
} from '../types';

import {
    useDefaultedRef,
} from 'tools/hooks';

import {
    ICreatePaymentDto,
} from 'entities/payments/requests/create-payment.dto';

export function usePaymentFormRef() {
    return useDefaultedRef<IRef>({
        getDto(): ICreatePaymentDto | null {
            return null;
        },
        validate(): boolean {
            return true;
        },
        setError(): void {
            return;
        },
    });
}
